import * as React from 'react'
import { Redirect } from 'react-router';
import '../styles/Login.css'
// import { login, resetPasswordRequest} from '../api/auth-api';

import headerLogo from '../images/header-logo-white.png';
import TextInput from '../components/text-input';
import { login, forgottenPasswordApi } from '../api/api-account';
import { PromiseHelper } from '../classes/promiseHelper';
import { LogInResponse } from '../api/dataTypes';

interface State {
  username: string,
  password: string,
  isLoggedIn: boolean,
  options: string[]
  disableInputs: boolean,
}

export interface Props {
}


export default class LoginPage extends React.Component<Props, State> {
  uNameRef: any;
  loginPromise: PromiseHelper<LogInResponse> = new PromiseHelper();

  constructor(props: Props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      isLoggedIn: false,
      options: [],
      disableInputs: false,
    }
    this.uNameRef = React.createRef();
  }

  componentWillUnmount() {
    this.loginPromise.clearPromise();
  }

  componentDidMount = () => {
    this.focusUserName();
  }

  focusUserName = () => {
    this.uNameRef.current.focus();
  }

  handleKeyPress = (e: any) => {
    if (e.key === 'Enter') {
      this.handleLogin();
    }
  }

  handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, parent?: string) => {
    let targetName = e.target.name;
    let val: string = e.target.value

    this.setState(prevState => ({
      ...prevState,
      [targetName]: val
    }));
  }

  handleLogin = () => {
    this.setState({ disableInputs: true });
    let user = this.state.username;
    let password = this.state.password;
    this.loginPromise.newPromise(
      login(user, password),
      t => {
        this.setState({
          isLoggedIn: true,
          disableInputs: false,
        });
      },
      error => {
        this.setState({ disableInputs: false });
        alert("Login failed. Please try again. \n" + error!.message);
        this.focusUserName();
      }
    )
  }

  handleForgotPassword = () => {
    //alert('TODO');
      if(this.state.username === null || this.state.username === ''){
        alert("To reset your password, please provide your email");
        return;
      }

      this.setState({disableInputs: true});

      console.log("Reseting password for " + this.state.username);
      forgottenPasswordApi(this.state.username)
      .then( result => {
        this.setState({disableInputs: false});
        if(result === true) {
          alert("Password reset link sent to the provided email");
        } else {
          alert("Failed to send password reset. Double check the provided email address")
        }
      })
  }

  render() {
    if (this.state.isLoggedIn === true) {// || isAuthenticated() === true) {
      return <Redirect to={{
        pathname: '/'
      }} />;
    } else {
      return (
        <div
          className="mt-5"
          onKeyPress={this.handleKeyPress}
        >
          <div className='d-flex justify-content-center' >
            <div className="col-lg-6 col-md-10 col-sm-12 login">
              <div className="d-flex justify-content-center">
                <img
                  className=""
                  src={headerLogo}
                  alt='BHS Logo'
                  width={250}
                />
              </div>
              <label className="header-text text-center col-12 mb-3 mt-3">
                You must login to continue:
              </label>

              <TextInput
                value={this.state.username}
                handleChange={this.handleInputChange}
                propName='username'
                title='Email'
                class='col-lg-12 col-md-12 mb-3'
                reference={this.uNameRef}
                disabled={this.state.disableInputs}
                inputType={'email'}
              />

              <TextInput
                value={this.state.password}
                handleChange={this.handleInputChange}
                propName='password'
                title='Password'
                class='col-lg-12 col-md-12 mb-5'
                inputType="password"
                disabled={this.state.disableInputs}
              />

              {this.renderButton()}
            </div>
          </div>
        </div>
      )
    }
  }

  renderButton = () => {
    return (
      <div className='d-flex justify-content-center'>
        <button
          className="btn button button-action"
          onClick={this.handleLogin}
          disabled={this.state.disableInputs}
        >
          Login
        </button>

        <button
          className="btn button button-muted ml-3"
          onClick={this.handleForgotPassword}
          disabled={this.state.disableInputs}
        >
          Forgot Password
        </button>
      </div>
    )
  }
}
